module.exports = __webpack_public_path__ + "8add2ab32e4c3bf7e2d10d8fbb789245.png";